// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__ziRJg","headerInner":"styles_headerInner__JAhR6","logo":"styles_logo__W4LZ7"};